/**
 * Ablauf beim Aufdecken: Erst drehen sich die Karten an den Plätzen um (alle sehen, wer was gelegt
 * hat), nach dieser Pause wandern sie gestapelt in die Tischmitte.
 */
export const GATHER_DELAY_S = 1.2;
